module.exports = __webpack_public_path__ + "img/how-to-steps.dda97468.jpg";